// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Nextgame_wrapper__1S2f1","button":"Nextgame_button__19839"};